document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('video').forEach(function (video) {
    video.muted = true;
    video.playsInline = true;
    var play = video.play();
    if (play && play.catch) play.catch(function () {});
  });

  function money(cents) {
    try {
      if (window.Shopify && Shopify.formatMoney) {
        return Shopify.formatMoney(cents, window.themeMoneyFormat || '${{amount}}');
      }
    } catch (e) {}
    return '$' + (Number(cents) / 100).toFixed(2);
  }

  document.querySelectorAll('[data-product-section]').forEach(function (section) {
    var form = section.querySelector('form[action*="/cart/add"]');
    var jsonEl = section.querySelector('[data-product-json]');
    var idInput = section.querySelector('[data-product-id-input]');
    var priceEl = section.querySelector('[data-product-price]');
    var btn = section.querySelector('[data-add-to-cart]');
    if (!form || !jsonEl || !idInput) return;

    var product;
    try {
      product = JSON.parse(jsonEl.textContent);
    } catch (e) {
      return;
    }
    if (!product || !product.variants) return;

    function selectedOptions() {
      return (product.options || []).map(function (_, i) {
        var checked = form.querySelector('input[name="option' + (i + 1) + '"]:checked');
        return checked ? checked.value : null;
      });
    }

    function findVariant(opts) {
      return product.variants.find(function (v) {
        return opts.every(function (opt, i) {
          return !opt || v['option' + (i + 1)] === opt;
        });
      });
    }

    function sync() {
      var variant = findVariant(selectedOptions()) || product.variants[0];
      if (!variant) return;
      idInput.value = String(variant.id);
      if (priceEl) priceEl.textContent = money(variant.price);
      if (btn) {
        btn.disabled = !variant.available;
        btn.textContent = variant.available ? 'Add to cart' : 'Sold out';
      }
    }

    form.querySelectorAll('.sz-input').forEach(function (input) {
      input.addEventListener('change', sync);
    });
    sync();
  });
});
